import { LidProvider } from './lid-provider/lid-provider';
import { EventProvider } from './event/event';
import { SessionProvider } from './session/session';
import { Injectable } from "@angular/core";

@Injectable()
export class EventDetailsService {
    eventHandleMode: EventHandleMode;

    constructor(
        private sessionProvider: SessionProvider,
        private lidProvider: LidProvider,
        private eventService: EventProvider
    ) { }

    detectEventHandleMode(detect: EventModeDetection) {
        this.eventHandleMode = EventHandleMode.REGISTER;
        this.sessionProvider.getToken(true, false).then(token => {
            if (!token) return;

            this.isEventOrganizer(detect.lidOrg).then(isOrganizer => {
                if (isOrganizer) { this.eventHandleMode = EventHandleMode.ORGANIZER; return; }

                this.isUserRegistered(detect.eventId).then(isRegistered => {
                    if (isRegistered) {
                        this.eventHandleMode = EventHandleMode.CHECK_IN;
                    }
                })
            });
        })
    }

    isEventOrganizer(lidOrg: number): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.lidProvider.getLid().then(lid => {
               resolve(!lidOrg || lid == lidOrg || lidOrg < 0)
            });
        });
    }

    isUserRegistered(eventId: number): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.eventService.isUserRegistered(eventId).then(result => {
                resolve(result);
            });
        });
    }
}

interface EventModeDetection {
    eventId: number,
    lidOrg: number
}
export enum EventHandleMode {
    REGISTER,
    CHECK_IN,
    ORGANIZER
}


// WEBPACK FOOTER //
// /src/providers/event-detailts.service.ts